export default __webpack_public_path__ + "static/media/premium.2643a9c4.png";